import { type FC } from 'react'
import classNames from 'classnames'

interface UpsellFeatureItemProps {
  title: string
  description: string
  className?: string
}

export const UpsellFeatureItem: FC<UpsellFeatureItemProps> = ({ title, description, className }) => {
  return (
    <div className={classNames('d-flex gap-2', className)}>
      <i className='bi bi-check-lg zocks-text-primary' />
      <div className='paragraph-medium'>
        <strong>{title}</strong>: {description}
      </div>
    </div>
  )
}
